export const calendarModals = {
  common: {
    cancel: "Cancelar",
  },
  arrival: {
    title: "Reglas del calendario",
    loading: "Cargando configuración…",
    daysTitle: "Días de entrada y salida",
    canArrive: "Se puede llegar",
    canDepart: "Se puede salir",
    daysHint:
      "Con <b>todos marcados</b> no hay restricción. Si solo permites llegar el lunes y salir el domingo, cada reserva durará una semana exacta.",
    summaryAny: "Se puede entrar y salir cualquier día",
    summaryArrival: "entrada en {n} de 7 días",
    summaryDeparture: "salida en {n} de 7 días",
    summaryRestricted: "Restringido: {detail}",
    cutoffTitle: "Cerrar la venta de hoy a partir de una hora",
    cutoffToggle: "Cerrar automáticamente la venta del día",
    cutoffToggleHint: "Mientras esté desactivado, aceptas entradas para hoy a cualquier hora.",
    cutoffFrom: "A partir de las",
    cutoffTz: "hora de tu alojamiento",
    cutoffTzNow: "allí son las {time}",
    cutoffHintPre: "Cada día, a las ",
    cutoffHintMid: " de ",
    cutoffHintPost:
      ", dejarás de recibir reservas para esa misma jornada. Los días siguientes siguen abiertos con normalidad.",
    cutoffSummaryOn: "Cada día se cierra la venta a las {time}",
    cutoffSummaryOff: "Aceptas entradas para hoy a cualquier hora",
    turnoverTitle: "Tiempo de preparación",
    turnoverQuestion: "¿Cuántas noches necesitas entre un huésped y el siguiente?",
    turnoverOptNone: "Ninguna",
    nights: "{count} noche | {count} noches",
    custom: "Personalizado",
    customLabel: "Noches",
    customAside: "a cada lado, hasta 7",
    turnoverSummaryNone: "Se puede entrar el mismo día que otro sale",
    turnoverSummarySet: "Reserva {nights} entre un huésped y el siguiente",
    turnoverLegacySummaryAfter: "Hoy solo se aplica tras la salida · guarda para cubrir los dos lados",
    turnoverLegacySummaryBefore: "Hoy solo se aplica antes de la entrada · guarda para cubrir los dos lados",
    turnoverLegacyNoteAfter: "Esta regla viene de la versión anterior y hoy solo bloquea tras la salida, no antes de la entrada. Al guardar se aplicará a los dos lados, y antes te diremos cuántas noches se cierran.",
    turnoverLegacyNoteBefore: "Esta regla viene de la versión anterior y hoy solo bloquea antes de la entrada, no tras la salida. Al guardar se aplicará a los dos lados, y antes te diremos cuántas noches se cierran.",
    exampleLabel: "Ejemplo",
    exampleCaption: "Una reserva que entra el 15 y sale el 18",
    legendStay: "Estancia",
    legendPrep: "Preparación",
    legendFree: "A la venta",
    turnoverMoveHint:
      "El bloqueo se mueve solo si cambian las fechas y desaparece si la reserva se cancela.",
    impactClosePre: "Se van a cerrar ",
    impactClosePost: " en tus canales.",
    impactOpenPre: "Se van a abrir ",
    impactOpenPost: ".",
    impactRetry: "Vuelve a pulsar «Guardar reglas» para aplicarlo.",
    fallbackHost: "tu alojamiento",
    saving: "Guardando…",
    applyYes: "Sí, aplicar",
    saveRules: "Guardar reglas",
    loadError: "No se pudo cargar la configuración.",
    saveSuccess: "Reglas del calendario guardadas y enviadas a tus canales.",
    saveError: "No se pudo guardar.",
    saveConfigError: "No se pudo guardar la configuración.",
    linkedTitle: "Venta del apartamento completo",
    linkedSummaryOff: "Esta unidad se vende por su cuenta",
    linkedSummaryOn: "Vende la casa entera · incluye {count} habitación | Vende la casa entera · incluye {count} habitaciones",
    linkedSummaryChild: "Forma parte de {parent}",
    linkedRooms: "{count} hab. | {count} hab.",
    linkedToggle: "Activar como apartamento completo del anuncio",
    linkedToggleHint: "Para la unidad que alquila la casa entera. Luego eliges qué habitaciones incluye.",
    linkedQuestion: "¿Qué habitaciones incluye?",
    linkedAll: "Marcar todas",
    linkedNone: "Quitar todas",
    linkedIsParent: "Ya se vende como completo",
    linkedGuests: "{count} huésped | {count} huéspedes",
    linkedExampleCaption: "Reservan «{room}» del 19 al 21",
    linkedExampleRoom: "Habitación 1",
    linkedLegendClosed: "Se cierra solo",
    linkedHint: "Y al revés: si reservan el completo, se cierran todas sus habitaciones. Si la reserva se cancela o cambia de fechas, todo se abre solo, también en tus canales. Mientras la reserva siga en pie, estos cierres no se pueden abrir a mano.",
    linkedChildPre: "Esta habitación forma parte de ",
    linkedChildPost: ". Si la reservan, ese completo se cierra esas noches; y si reservan el completo, esta habitación se cierra sola. Se cambia desde las reglas del calendario del completo.",
    linkedConflicts: "Ya hay {count} doble venta entre el completo y sus habitaciones. Revísala: | Ya hay {count} dobles ventas entre el completo y sus habitaciones. Revísalas:",
    linkedNeedsRooms: "Marca al menos una habitación que incluya el apartamento completo.",
    linkedSaveError: "No se pudo guardar la venta del apartamento completo.",
    linkedAlertTitle: "«{unit}» pasa a ser el apartamento completo",
    linkedAlertBody: "Si la reservan, se cerrarán automáticamente las habitaciones que marques, aquí y en tus canales (Booking, Airbnb…). Y si reservan cualquiera de ellas, esta se cerrará esas noches. Si la reserva se cancela, todo vuelve a abrirse solo.",
    linkedPartialSave: "Se guardó la venta del apartamento completo, pero no el resto de reglas. Vuelve a intentarlo.",
  },
  weekend: {
    title: "Configuración de precios",
    subtitle: "Esta información aparecerá todas las noches, a menos que la personalices por fecha.",
    loading: "Cargando configuración...",
    plTitle: "Precios gestionados por PriceLabs",
    plDesc1:
      "Esta propiedad tiene la gestión dinámica de precios activa con PriceLabs. Los precios se actualizan automáticamente según la demanda, temporada y ocupación.",
    plDesc2: "Para modificar precios de fin de semana, hazlo directamente desde tu panel de PriceLabs.",
    plOpen: "Abrir PriceLabs",
    basePriceTitle: "Precio base",
    basePriceLabel: "Por noche — se aplica todos los días",
    customization: "Personalización",
    weekendPriceTitle: "Precio fin de semana",
    toggleOff: "Desactivar precio fin de semana",
    toggleOn: "Activar precio fin de semana",
    appliesTo: "Aplica los:",
    weekendLabel: "Fin de semana",
    infoHint: "Se aplicará a los próximos <strong>500 días</strong> en los días seleccionados.",
    disabledText: "Los días de fin de semana usarán el precio base de",
    confirmTitle: "¿Desactivar precio de fin de semana?",
    confirmDescPre: "Los días volverán al precio base de",
    confirmDescPost: "automáticamente.",
    disabling: "Desactivando...",
    confirmDisable: "Sí, desactivar",
    saving: "Guardando...",
    saveChanges: "Guardar cambios",
    diffEqual: "igual al base",
    diffUp: "+{pct}% vs base",
    diffDown: "{pct}% vs base",
    loadError: "Error al cargar la configuración de precios",
    disableSuccess: "Precio de fin de semana desactivado. Los días vuelven al precio base.",
    disableError: "Error al desactivar el precio de fin de semana",
    saveSuccess: "Precios guardados correctamente",
    saveError: "Error al guardar",
  },
};
